
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSoundNoFill as ObiSoundNoFillElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sound-no-fill.js';
 
 
 

 
 export const ObiSoundNoFill = createComponent({
   react: React,
   tagName: 'obi-sound-no-fill',
   elementClass: ObiSoundNoFillElement,
   events: {
     
   }
  });
 
 